export default __webpack_public_path__ + "static/media/w_wallpaper.29f901c0.jpeg";